import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import type { FC, ReactNode } from 'react';

type DeployStepSectionProps = {
  stepNumber: number;
  title: string;
  complete: boolean;
  dimmed?: boolean;
  isLast?: boolean;
  children: ReactNode;
};

const DeployStepSection: FC<DeployStepSectionProps> = ({
  stepNumber,
  title,
  complete,
  dimmed = false,
  isLast = false,
  children,
}) => (
  <Box display="flex" style={{ gap: 20, opacity: dimmed ? 0.55 : 1 }}>
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      style={{ width: 28, flexShrink: 0 }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: complete ? '#3182CE' : '#E2E8F0',
          color: complete ? '#FFFFFF' : '#718096',
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        {complete ? <CheckIcon style={{ fontSize: 18 }} /> : stepNumber}
      </Box>
      {!isLast && (
        <Box
          style={{
            width: 2,
            flex: 1,
            minHeight: 24,
            background: '#E2E8F0',
            marginTop: 4,
          }}
        />
      )}
    </Box>
    <Box flex={1} style={{ paddingBottom: isLast ? 0 : 32, minWidth: 0 }}>
      <Typography
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: '#2D3748',
          marginBottom: 8,
          lineHeight: 1.4,
        }}
      >
        {stepNumber}. {title}
      </Typography>
      {children}
    </Box>
  </Box>
);

export default DeployStepSection;
